/* eslint-disable no-console */
import { ISafeAny } from './label.type';

export const logger = {
  info(...args: ISafeAny) {
    console.log('[@bixi/label:angular]', ...args);
  },
  warn(...args: ISafeAny) {
    console.warn('[@bixi/label:angular]', ...args);
  },
  error(...args: ISafeAny) {
    console.error('[@bixi/label:angular]', ...args);
  }
};
